module.exports = __webpack_public_path__ + "static/media/introduce_more5.546fb842.png";